export class BreadCrumbsConstants {

  // Important: Order matters. For more info, check https://www.npmjs.com/package/use-react-router-breadcrumbs .
  static readonly Routes = [
    { path: "/home", breadcrumb: "Home" },
    { path: "/home/dashboard", breadcrumb: "Dashboard" },
    { path: "/home/administration", breadcrumb: "Administration" },
    { path: "/home/administration/users", breadcrumb: "Users" },
    { path: "/home/administration/user-categories", breadcrumb: "User Categories" },
    { path: "/home/time-and-attendance", breadcrumb: "Attendance" },
    { path: "/home/time-off-management", breadcrumb: "Time-Off" },
    { path: "/home/manage-profile", breadcrumb: "Profile Summary" },
    { path: "/home/time-and-attendance/shift-category", breadcrumb: "Shift Category" },
    { path: "/home/time-and-attendance/shift-details", breadcrumb: "Shift Details" }
  ];
}
